import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  OnDestroy,
  AfterViewInit,
  Inject,
} from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { TableColumn } from 'src/app/core/components/table/TableColumn';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { TooltipPosition } from '@angular/material/tooltip';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AlertComponent } from 'src/app/core/components/alert/alert.component';
import { ShipmentService } from 'src/app/shared/services/shipment.service';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import {
  TRACKING_BASE_URL,
  shipmentStatusMap,
  allconfig,
  configurationIdMapForProductName,
} from 'src/app/utils/constants/constant';
import { ShipmentDetailsComponent } from 'src/app/modules/shipment/shipment-details/shipment-details.component';
import { UploadComponent } from '../../mapping/upload/upload.component';
import { convertBabyShipment } from 'src/app/modules/shipment/shipment-list/convertors/baby-shipments';
import { BehaviourService } from '../../../shared/services/behaviour.service';
import { SelectionModel } from '@angular/cdk/collections';
import { compareArrayElements, isObjectEmpty } from '../../../utils/utils';
import { Subscription, forkJoin, merge, of, from, of as observableOf } from 'rxjs';
import { SnackBarService } from '../../../shared/snack-bar/services/snack-bar.service';
import { Days } from '../../../utils/constants/utility';
import * as FileSaver from 'file-saver';
import { CustomerOnboardingComponent } from '../../configuration/customer-onboarding/customer-onboarding.component';
import { LabelViewComponent } from 'src/app/shared/label-view/label-view.component';
import {
  catchError,
  concatMap,
  debounceTime,
  distinctUntilChanged,
  first,
  map,
  startWith,
  switchMap,
} from 'rxjs/operators';
import { createConfig, createConfigArray } from 'src/app/utils/default-configs/configuration';
import { DexieDbService } from 'src/app/shared/services/dexie-db.service';
import { TranslateService } from '@ngx-translate/core';

interface tableData {
  shipmentID: number;
  shipmentDate: string;
  transitDate: string;
  shipperName: string;
  customerReference: string;
  productCode: string;
  DestinationCountry: string;
  receiverName: string;
  shipmentStatus: string;
  OriginCountry: string;
  shipper_id: string;
  receiver_id: string;
}

@Component({
  selector: 'app-shipment-list',
  templateUrl: './shipment-list.component.html',
  styleUrls: ['./shipment-list.component.scss'],
})
export class ShipmentListComponent implements OnInit, OnDestroy, AfterViewInit {
  selection = new SelectionModel<any>(true, []);
  deleteDisable: boolean = false;
  generateLabelDisable: boolean = false;
  isAllShipmentCreated: boolean = true;
  selectedShipment = [];
  selectedTabForStatus: number = 0;
  serviceSubscription$ = new Subscription();
  processDone: string = '';
  public AdvFilterForm: FormGroup;
  mappingTableColumns: TableColumn[];
  allConfigSpecList = [];
  @ViewChild('dialogRef')
  dialogRef!: TemplateRef<any>;
  name = 'Angular';
  fromdate: any;
  todate: any;
  shipmentID: any;
  receiverID: any;
  shipmentid: any;
  shipperReference: any;
  receiverName: any;
  configInvoices: string = '';
  receiver_id: any;
  fieldArray: Array<number> = [0];
  selectedLangs = new Set<string>();
  positionOptions: TooltipPosition[] = ['below'];
  position = new FormControl(this.positionOptions[0]);
  defaultShipmentList: any = [];
  dataSource = new MatTableDataSource<tableData>();
  displayedColumns: string[] = [
    'shipmentSelected',
    'shipmentID',
    'customerReference',
    'mawbId',
    'dServiceCode',
    'shipmentDate',
    'transitDate',
    'shipperCompanyName',
    'shipperCountryCode',
    'receiverCompanyName',
    'receiverCountryCode',
    'noOfPieces',
    'totalWeight',
    'status',
    'productCode',
  ];
  defaultColumns = [];
  pieceLevelLabelPrint: boolean;
  selectedPieces = [];
  searchPlaceHolder: string;
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  linkPieceSubscription$ = new Subscription();
  responseLoaded: Promise<boolean>;
  selectAllShipments = [];
  looseBbx: boolean;
  bbxWorkflow: any;
  manifestFailed: boolean = false;
  manifestFailedMsg: string;
  decimalValue;
  totalData;
  pageSizes = [25, 50, 100, 200];
  searchKeywordFilter = new FormControl();
  actionPerformed: string;
  paperLesstTrade: boolean;
  nonDocProductCodes = [];
  constructor(
    private fb: FormBuilder,
    private shipmentService: ShipmentService,
    private configService: ConfigService,
    private dialog: MatDialog,
    private errorDialogService: ErrorDialogService,
    private behaviourService: BehaviourService,
    private snackBarService: SnackBarService,
    private dexieDbService: DexieDbService,
    private translateService: TranslateService
  ) {}

  get tooltipTextPieceLevel(): string {
    const verify = this.isVerifyPiecesGenerateLabel();

    if (verify.piecesOnlyIndividualShips) {
      return 'shipment.shipmentList.labelOnlyForNonIndShip';
    }

    if (verify.piecesBreakbulkShips) {
      return 'shipment.shipmentList.invalidShipmentsToGenerateLabel';
    }

    return 'shipment.shipmentList.generateBatchLabel';
  }

  get tooltipTextShipmentLevel(): string {
    const verify = this.isVerifyGenerateLabel();

    if (verify.onlyIndividualShips) {
      return 'shipment.shipmentList.labelOnlyForNonIndShip';
    }

    if (verify.breakbulkShips) {
      return 'shipment.shipmentList.invalidShipmentsToGenerateLabel';
    }

    if (this.selectedTabForStatus === 0) {
      return 'shipment.shipmentList.generateBatchLabel';
    } else {
      return 'shipment.shipmentList.viewGeneratedLabel';
    }
  }

  ngOnInit(): void {
    this.getManifestFailedStatus();
    this.getListQuery();
    this.filterBySearch();
    this.initializationformGroup();
    this.getUpdatedData();
    // this.getInvoiceConfigs();
    this.validateDefaultConfiguration();
    // this.getPiecesConfig();
    this.searchListDisplay();
    // this.getWorkflowConfig();
    // this.getDecimalUnitPrice();
    this.checkIndexedTableData();
    this.getProductCodeValues();
  }

  getManifestFailedStatus() {
    this.shipmentService.getManifestFailedShipment().subscribe((data: any) => {
      if (data) {
        this.manifestFailed = true;
        this.manifestFailedMsg = '';

        this.translateService.get('shipment.shipmentList.noteLabel').subscribe((res: string) => {
          this.manifestFailedMsg = res + data;
        });
      } else {
        this.manifestFailed = false;
      }
    });
  }

  validateDefaultConfiguration() {
    this.configService.validateConfiguration().subscribe((response: any) => {
      if (response?.length > 0) {
        this.openCustomerOnBoarding(response);
      }
    });
  }

  openCustomerOnBoarding(response) {
    const onBoardingDialogRef = this.dialog.open(CustomerOnboardingComponent, {
      disableClose: true,
      autoFocus: false,
      maxHeight: '100vh',
      width: '90vw',
      maxWidth: '90vw',
    });

    this.behaviourService.sendArrayEvent(response, 'VERIFY');
    onBoardingDialogRef.afterClosed().subscribe(() => ``);
  }

  onStatusTabChange(event) {
    this.actionPerformed = event?.dataAction;
    if (!(this.actionPerformed == 'update' || this.actionPerformed == 'delete')) {
      this.paginator.pageIndex = 0;
    }
    this.sort.active = 'shipmentDate';
    this.selectedTabForStatus = event.index;
    this.selection.clear();
    this.selectedShipment = [];
    this.selectedPieces = [];
    if (event.index === 2) {
      this.displayedColumns = [...this.defaultColumns, 'track'];
    } else {
      this.displayedColumns = this.defaultColumns;
    }
    this.getPLTValue();
    return this.getSpecificationsList(this.getCurrentStatus(this.selectedTabForStatus));
  }

  getCurrentStatus(currentTab: number) {
    const shipmentStatusConfigs = {
      0: () => [
        shipmentStatusMap.CREATED,
        shipmentStatusMap.VALIDATION_FAILED,
        shipmentStatusMap.USER_INPUT_REQUIRED,
        shipmentStatusMap.PARTIALLY_LABEL_GENERATED,
        shipmentStatusMap.DRAFT,
      ],
      1: () => [shipmentStatusMap.LABEL_GENERATED],
      2: () => [shipmentStatusMap.MANIFESTED, shipmentStatusMap.MANIFESTATION_FAILED],
      default: () => ``,
    };
    return (shipmentStatusConfigs[currentTab] || shipmentStatusConfigs.default)();
  }

  getInvoiceConfigs() {
    this.serviceSubscription$.add(
      from(this.configService.fetchConfig('default_invoice_export')).subscribe(response => {
        if (response) {
          if (isObjectEmpty(response)) {
            this.saveExportInvoice();
          } else {
            this.configInvoices = response?.data[0];
            sessionStorage.setItem('isCustomInvoice', this.configInvoices);
          }
        }
      })
    );
  }

  saveExportInvoice() {
    const configData = {
      config_id: 'default_invoice_export',
      data: ['Default'],
    };
    this.saveConfig(configData);
  }

  saveConfig(config) {
    this.configService
      .saveConfig(config)
      .subscribe(() => sessionStorage.setItem('isCustomInvoice', 'Default'));
  }

  initializationformGroup() {
    this.AdvFilterForm = this.fb.group({
      shipmentID: ['', Validators.required],
      PID: ['', Validators.required],
      customerReference: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      receiverName: ['', Validators.required],
    });
  }

  isAdvancedFilterCheck() {
    return !(
      this.AdvFilterForm.get('shipmentID').valid ||
      this.AdvFilterForm.get('PID').valid ||
      this.AdvFilterForm.get('customerReference').valid ||
      this.AdvFilterForm.get('receiverName').valid ||
      (this.AdvFilterForm.get('startDate').valid && this.AdvFilterForm.get('endDate').valid)
    );
  }

  addFieldValue() {
    this.fieldArray.push(this.fieldArray.length);
  }

  deleteFieldValue(index: number, lang: string) {
    this.selectedLangs.delete(lang);
    this.fieldArray.splice(index, 1);
  }

  isSelected(lang: string) {
    return this.selectedLangs.has(lang);
  }

  openTempDialog() {
    const myTempDialog = this.dialog.open(this.dialogRef, { data: '' });
    myTempDialog.afterClosed().subscribe(() => ``);
  }

  closeDialog() {
    this.dialog.closeAll();
    this.AdvFilterForm.reset();
  }

  initMappingColumns(): void {
    this.mappingTableColumns = [];
    if (this.allConfigSpecList.length > 0) {
      for (const key in this.allConfigSpecList[0]) {
        const columnObj: any = {};
        columnObj.name = key.replace(/([a-z])([A-Z])/g, '$1 $2');
        columnObj.dataKey = key;
        this.mappingTableColumns.push(columnObj);
      }
    }
  }

  dateAppend(date: string) {
    if (date.length < 2) {
      return '0' + date;
    }
  }

  getListQuery() {
    this.mappingTableColumns = [];
    const lastThirtyDays = new Date();
    lastThirtyDays.setDate(lastThirtyDays.getDate() - Days.MONTH);

    const d = new Date();
    let month = '' + (d.getMonth() + 1),
      day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    let fromMonth = (lastThirtyDays.getMonth() + 1).toString();
    let fromDate = lastThirtyDays.getDate().toString();
    if (fromMonth.toString().length < 2) {
      fromMonth = this.dateAppend(fromMonth.toString());
    }
    if (fromDate.toString().length < 2) {
      fromDate = this.dateAppend(fromDate.toString());
    }
    this.fromdate = `${lastThirtyDays.getFullYear()}${fromMonth}${fromDate}`;
    this.todate = year + month + day;
  }

  getSpecificationsList(status = []) {
    this.getListQuery();
    const rQuery = {
      query: {
        daterange: {
          datefield: this.getDateBasedOnTabFOrQuery(this.selectedTabForStatus),
          fromdate: this.fromdate,
          todate: this.todate,
        },
        status,
      },
      limit: this.paginator.pageSize,
      page: this.actionPerformed ? this.paginator.pageIndex + 1 : 1,
      search: this.searchKeywordFilter.value == null ? '' : this.searchKeywordFilter.value,
      sort:
        this.sort.active === 'shipmentDate'
          ? this.getDateBasedOnTab(this.selectedTabForStatus)
          : this.sort.active,
      sortOrder: this.sort.direction === 'desc' ? -1 : 1,
    };
    this.configService.getallSpecList(rQuery).subscribe(data => {
      this.assignDataSource(data);
    });
  }

  assignDataSource(data) {
    if (data?.data?.length > 0) {
      this.totalData = data?.totalCount;
    } else {
      this.totalData = 0;
    }
    this.defaultShipmentList = this.allConfigSpecList = convertBabyShipment(
      data.data,
      this.selectedTabForStatus
    );
    this.dataSource = new MatTableDataSource(data.data);
    this.dataSource.data = this.allConfigSpecList;
    this.actionPerformed = '';
  }

  getPageData() {
    return this.dataSource._pageData(this.dataSource._orderData(this.dataSource.data));
  }

  isEntirePageSelected() {
    return this.getPageData().every(row => this.selection.isSelected(row));
  }

  masterToggle() {
    this.isEntirePageSelected()
      ? this.selection.deselect(...this.getPageData())
      : this.selection.select(...this.getPageData());

    this.updateSelection();
  }

  updateSelection() {
    this.selectedShipment = this.selection.selected.map(item => item.shipmentID);
    this.selectedPieces = this.selection.selected.map(item => (item?.pieceID ? item.pieceID : ''));
  }

  get allShipmentsSelected(): boolean {
    this.selectedShipment = this.selection.selected.map(shipment => shipment.shipmentID);
    return (
      !!this.dataSource.data.length &&
      this.selection.selected.length === this.dataSource.data.length
    );
  }

  get allPiecesSelected(): boolean {
    this.selectedPieces = this.selection.selected.map(shipment => shipment.pieceID);
    return (
      !!this.dataSource.data.length &&
      this.selection.selected.length === this.dataSource.data.length
    );
  }

  toggleMasterShipmentsSelection() {
    return this.allShipmentsSelected
      ? this.selection.clear()
      : this.selection.select(...this.dataSource.data);
  }

  isVerifyGenerateLabel() {
    const breakbulkShips = compareArrayElements(
      this.selectedShipment,
      this.defaultShipmentList
        .filter(
          shipment =>
            shipment.status === shipmentStatusMap.VALIDATION_FAILED ||
            shipment.status === shipmentStatusMap.USER_INPUT_REQUIRED ||
            shipment.status === shipmentStatusMap.DRAFT
        )
        .map(shipment => shipment.shipmentID)
    );

    const onlyIndividualShips = compareArrayElements(
      this.selectedShipment,
      this.defaultShipmentList
        .filter(shipment => !['A', 'B'].includes(shipment.productCode))
        .map(shipment => shipment.shipmentID)
    );

    return { onlyIndividualShips, breakbulkShips };
  }

  isVerifyPiecesGenerateLabel() {
    const piecesBreakbulkShips = compareArrayElements(
      this.selectedPieces,
      this.defaultShipmentList
        .filter(
          shipment =>
            (shipment.status === shipmentStatusMap.VALIDATION_FAILED ||
              shipment.status === shipmentStatusMap.USER_INPUT_REQUIRED ||
              shipment.status === shipmentStatusMap.DRAFT ||
              shipment.pieceStatus === 'GENERATED' ||
              shipment.pieceStatus === 'Generated' ||
              shipment.pieceStatus === '') &&
            this.selectedTabForStatus !== 2
        )
        .map(shipment => shipment.pieceID)
    );

    const piecesOnlyIndividualShips = compareArrayElements(
      this.selectedPieces,
      this.defaultShipmentList
        .filter(shipment => !['A', 'B'].includes(shipment.productCode))
        .map(shipment => shipment.pieceID)
    );

    return { piecesOnlyIndividualShips, piecesBreakbulkShips };
  }
  isVerifyPiecesViewLabel() {
    return compareArrayElements(
      this.selectedPieces,
      this.defaultShipmentList
        .filter(
          shipment =>
            shipment.status === shipmentStatusMap.VALIDATION_FAILED ||
            shipment.status === shipmentStatusMap.USER_INPUT_REQUIRED ||
            shipment.pieceStatus === 'NOT GENERATED' ||
            shipment.pieceStatus === 'Not Generated' ||
            shipment.pieceStatus === ''
        )
        .map(shipment => shipment.pieceID)
    );
  }

  openShipmentDetails(element) {
    const shipmentDetailsDialogRef = this.dialog.open(ShipmentDetailsComponent, {
      disableClose: true,
      autoFocus: false,
      maxHeight: '100vh',
      maxWidth: '90vw',
      data: {
        shipmentId: element.shipmentID,
        shipperId: element.shipper_id,
        receiverId: element.receiver_id,
        configInvoices: this.configInvoices,
        tabName: this.selectedTabForStatus,
        decimalValue: this.decimalValue,
        status: element.status,
        looseBbx: this.looseBbx,
      },
    });
    shipmentDetailsDialogRef.afterClosed().subscribe(result => {
      this.getManifestFailedStatus();
      if (result?.data?.shipmentID) {
        this.onStatusTabChange({ index: 0, dataAction: 'update' });
        this.openShipmentDetails(result?.data);
      } else if (result?.data && result?.data == 'remanifest') {
        this.onStatusTabChange({ index: 2, dataAction: 'update' });
      }
    });
  }

  getTrackUrl(element) {
    return `${TRACKING_BASE_URL}/results?id=${element.shipmentID}`;
  }

  getUpdatedData() {
    this.behaviourService.currentMessage.subscribe(message => {
      if (message === 'labelGenerated' || message === 'uploadSuccessful') {
        this.onStatusTabChange({ index: 0 });
      }
      this.processDone = message;
    });
  }

  applyAdvFilter() {
    this.shipmentID = [];
    this.shipperReference = [];
    this.dialog.closeAll();
    if (this.AdvFilterForm.value.startDate) {
      const d = this.AdvFilterForm.value.startDate._d;
      let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate();
      const year = d.getFullYear();
      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }
      this.fromdate = year + month + day;
    }
    if (this.AdvFilterForm.value.endDate) {
      const d = this.AdvFilterForm.value.endDate._d;
      let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate();
      const year = d.getFullYear();
      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }
      this.todate = year + month + day;
    }
    if (this.AdvFilterForm.value.shipmentID) {
      this.shipmentID.push(this.AdvFilterForm.value.shipmentID.trim());
    } else {
      this.shipmentID.push('');
    }
    if (this.AdvFilterForm.value.customerReference) {
      this.shipperReference.push(this.AdvFilterForm.value.customerReference.trim());
    } else {
      this.shipperReference.push('');
    }
    if (this.AdvFilterForm.value.receiverName) {
      this.receiverID = this.AdvFilterForm.value.receiverName.trim();
    } else {
      this.receiverID = '';
    }
    let rQuery;
    if (!this.AdvFilterForm.value.startDate) {
      rQuery = {
        query: {
          shipmentID: this.shipmentID,
          shipperReference: this.shipperReference,
          receiver_id: [this.receiverID],
          status: this.getCurrentStatus(this.selectedTabForStatus),
        },
        limit: this.paginator.pageSize,
        page: 1,
        search: '',
        sort:
          this.sort.active === 'shipmentDate'
            ? this.getDateBasedOnTab(this.selectedTabForStatus)
            : this.sort.active,
        sortOrder: this.sort.direction === 'desc' ? -1 : 1,
      };
    } else {
      rQuery = {
        query: {
          shipmentID: this.shipmentID,
          shipperReference: this.shipperReference,
          daterange: {
            datefield: this.getDateBasedOnTabFOrQuery(this.selectedTabForStatus),
            fromdate: this.fromdate,
            todate: this.todate,
          },
          status: this.getCurrentStatus(this.selectedTabForStatus),
          receiver_id: [this.receiverID],
        },
        limit: this.paginator.pageSize,
        page: 1,
        search: '',
        sort:
          this.sort.active === 'shipmentDate'
            ? this.getDateBasedOnTab(this.selectedTabForStatus)
            : this.sort.active,
        sortOrder: this.sort.direction === 'desc' ? -1 : 1,
      };
    }

    this.configService.getallSpecList(rQuery).subscribe(data => {
      this.assignDataSource(data);
    });
    this.AdvFilterForm.reset();
  }

  filterBySearch() {
    this.searchKeywordFilter.valueChanges
      .pipe(debounceTime(3000), distinctUntilChanged())
      .subscribe(newValue => {
        const rQuery = {
          query: {
            daterange: {
              datefield: this.getDateBasedOnTabFOrQuery(this.selectedTabForStatus),
              fromdate: this.fromdate,
              todate: this.todate,
            },
            status: this.getCurrentStatus(this.selectedTabForStatus),
          },
          limit: this.paginator.pageSize,
          page: 1,
          search: this.searchKeywordFilter.value == null ? '' : this.searchKeywordFilter.value,
          sort:
            this.sort.active === 'shipmentDate'
              ? this.getDateBasedOnTab(this.selectedTabForStatus)
              : this.sort.active,
          sortOrder: this.sort.direction === 'desc' ? -1 : 1,
        };
        this.configService.getallSpecList(rQuery).subscribe(data => {
          this.assignDataSource(data);
        });
        this.paginator.pageIndex = 0;
      });
  }

  createShipments() {
    const shipmentDetailsCreateDialogRef = this.dialog.open(ShipmentDetailsComponent, {
      disableClose: true,
      autoFocus: false,
      maxHeight: '100vh',
      maxWidth: '90vw',
      data: {
        action: 'create',
        configInvoices: this.configInvoices,
        decimalValue: this.decimalValue,
      },
    });
    shipmentDetailsCreateDialogRef.afterClosed().subscribe(result => {
      if (result?.data?.shipmentID) {
        this.onStatusTabChange({ index: 0 });
        this.openShipmentDetails(result?.data);
      }
    });
  }

  uploadShipments() {
    const dialogRef = this.dialog.open(UploadComponent, {
      autoFocus: false,
      width: '75vw',
      maxHeight: '100vh',
      maxWidth: '90vw',
      data: {
        isOpeningFrom: 'uploadShipment',
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.onStatusTabChange({ index: 0 });
      }
    });
  }

  deleteShipment(id) {
    this.shipmentService.deleteShipment(id).subscribe((data: any) => {
      if (data.Message) {
        this.errorDialogService.openDialog(data.Message, false);
      } else {
        this.onStatusTabChange({ index: this.selectedTabForStatus });
      }
    });
  }

  ngOnDestroy(): void {
    this.serviceSubscription$.unsubscribe();
    this.behaviourService.sendEvent(null);
    this.linkPieceSubscription$.unsubscribe();
  }

  generateLabelShipments() {
    this.deleteDisable = true;
    const shipmentStatusConfigs = {
      0: () => {
        this.shipmentService.generateBatchLabel(this.selectedShipment).subscribe({
          next: (response: any) => {
            if (response.hasOwnProperty('path')) {
              this.downloadLabel(`${response?.path}`);
            }
            this.deleteDisable = false;
            this.snackBarService.dismissSnackbar();
            this.selectedShipment = [];
            this.onStatusTabChange({ index: this.selectedTabForStatus });
          },
          error: () => {
            this.deleteDisable = false;
            this.snackBarService.dismissSnackbar();
          },
        });
      },
      1: () => {
        this.shipmentService.fetchBatchLabel(this.selectedShipment).subscribe({
          next: (response: any) => {
            if (response.hasOwnProperty('path')) {
              this.downloadLabel(`${response?.path}`);
            }
            this.deleteDisable = false;
            this.snackBarService.dismissSnackbar();
            this.selectedShipment = [];
            this.onStatusTabChange({ index: this.selectedTabForStatus });
          },
          error: () => {
            this.deleteDisable = false;
            this.snackBarService.dismissSnackbar();
          },
        });
      },
      default: () => ``,
    };

    const sel = this.selectedTabForStatus == 2 ? 1 : this.selectedTabForStatus;

    return (shipmentStatusConfigs[sel] || shipmentStatusConfigs.default)();
  }

  downloadLabel(url) {
    const regex = /\/([^\/?#]+)\?/;
    const match = url.match(regex);
    FileSaver.saveAs(url, `${match[1]}`);
    const requestBody = { body: { path: `${match[1]}` } };
    this.shipmentService.deleteShipmentLabel(requestBody).subscribe(() => ``);
  }

  deleteShipments(shipmentsSelected, confirm = false) {
    this.generateLabelDisable = true;
    this.shipmentService.deleteBatchShipments(shipmentsSelected, confirm).subscribe({
      next: () => {
        this.generateLabelDisable = false;
        this.onStatusTabChange({ index: this.selectedTabForStatus, dataAction: 'delete' });
        this.selectedShipment = [];
        this.selectedPieces = [];
      },
      error: error => {
        this.generateLabelDisable = false;
        this.confirmDeleteLinkedShipments(error?.error?.Message, error?.error?.linkedShipments);
      },
    });
  }

  confirmDeleteLinkedShipments(error, linkedShipments) {
    if (error.includes('Shipment IDs') || `货件ID`) {
      this.openDialogDelete(error, linkedShipments);
    }
  }

  openDialogDelete(error, linkedShipments) {
    const dialogRef = this.dialog.open(AlertComponent, {
      data: {
        message: error,
        buttonText: {
          ok: 'Yes',
          cancel: 'No',
        },
      },
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data === 'true') {
        this.deleteShipments(linkedShipments, true);
      }
    });
  }

  getPiecesConfig() {
    this.configService.fetchConfig('label_print_config').then(response => {
      this.pieceLevelLabelPrint = response?.data[0]?.printPieceLevel == 'Yes' ? true : false;
      this.searchPlaceHolder = !this.pieceLevelLabelPrint
        ? 'shipment.shipmentList.searchShipment'
        : 'shipment.shipmentList.searchPiece';
      this.displayedColumns = !this.pieceLevelLabelPrint
        ? [
            'shipmentSelected',
            'shipmentID',
            'customerReference',
            'mawbId',
            'dServiceCode',
            'shipmentDate',
            'transitDate',
            'shipperCompanyName',
            'shipperCountryCode',
            'receiverCompanyName',
            'receiverCountryCode',
            'noOfPieces',
            'totalWeight',
            'status',
            'productCode',
          ]
        : [
            'shipmentSelected',
            'pieceID',
            'pieceReference',
            'mawbId',
            'dServiceCode',
            'shipmentDate',
            'transitDate',
            'shipmentID',
            'customerReference',
            'receiverCompanyName',
            'receiverCountryCode',
            'status',
            'productCode',
            'pieceStatus',
            'pieceAction',
          ];
      this.getPLTValue();
      this.defaultColumns = this.displayedColumns;
      this.responseLoaded = Promise.resolve(true);
    });
  }
  generateIndividualPieceLabel(pieceId, shipmentID, productCode) {
    this.selectedPieces = [];
    if (productCode === 'A' || productCode === 'B') {
      this.selectedPieces.push(pieceId);

      this.shipmentService.generatePiecesBatchLabel(this.selectedPieces).subscribe({
        next: () => {
          this.viewIndividualPieceLabel(pieceId);
          this.behaviourService.sendEvent('labelGenerated');
          this.onStatusTabChange({ index: 0 });
        },
        error: () => {
          this.deleteDisable = false;
          this.snackBarService.dismissSnackbar();
        },
      });
    } else {
      if (productCode) {
        this.manifestIndividualBabyshipment(shipmentID, productCode).subscribe(res =>
          this.handleManifestResponse(shipmentID, res)
        );
      }
    }
  }

  generateBatchPieceLabel() {
    this.shipmentService.generatePiecesBatchLabel(this.selectedPieces).subscribe({
      next: (response: any) => {
        if (response.hasOwnProperty('path')) {
          this.downloadLabel(`${response?.path}`);
        }
        this.deleteDisable = false;
        this.snackBarService.dismissSnackbar();
        this.selectedPieces = [];
        this.onStatusTabChange({ index: this.selectedTabForStatus });
      },
      error: () => {
        this.deleteDisable = false;
        this.snackBarService.dismissSnackbar();
      },
    });
  }

  viewIndividualPieceLabel(pieceId) {
    this.selectedPieces = [];
    this.selectedPieces.push(pieceId);
    this.shipmentService.fetchPiecesBatchLabel(this.selectedPieces).subscribe({
      next: () => {
        this.printLabel(pieceId);
      },
      error: () => {
        this.deleteDisable = false;
        this.snackBarService.dismissSnackbar();
      },
    });
  }

  printLabel(pieceId) {
    this.shipmentService.getLabel('pieceID', pieceId).subscribe({
      next: data => {
        this.shipmentService.labelWindowPrint(data.label);
      },
    });
  }
  viewLabel(pieceId, shipmentID, productCode) {
    if (productCode === 'A' || productCode === 'B') {
      this.shipmentService.getLabel('pieceID', pieceId).subscribe({
        next: data => {
          this.openPrintView(data.label, pieceId);
        },
      });
    } else {
      if (productCode) {
        this.shipmentService.getIndividuaShiplabel('individualShipmentID', shipmentID).subscribe({
          next: data => {
            this.openPrintView(data.label, shipmentID);
          },
        });
      }
    }
  }

  openPrintView(value, pieceId) {
    const dialogRef = this.dialog.open(LabelViewComponent, {
      data: {
        label: value,
        labelName: '',
        //  labelName: `DHL_BBX_Label_${pieceId}`,
        format: 'pdf',
      },
      maxHeight: '90vh',
      maxWidth: '50vw',
    });

    dialogRef.afterClosed().subscribe(() => ``);
  }

  batchViewPieceLabel() {
    this.shipmentService.fetchPiecesBatchLabel(this.selectedPieces).subscribe({
      next: (response: any) => {
        if (response.hasOwnProperty('path')) {
          this.downloadLabel(`${response?.path}`);
        }
        this.deleteDisable = false;
        this.snackBarService.dismissSnackbar();
        this.selectedPieces = [];
        this.onStatusTabChange({ index: this.selectedTabForStatus });
      },
      error: () => {
        this.deleteDisable = false;
        this.snackBarService.dismissSnackbar();
      },
    });
  }

  searchListDisplay() {
    this.linkPieceSubscription$.add(
      this.behaviourService.currentMessage.pipe(first()).subscribe(response => {
        if (response) {
          if (parseInt(response)) {
            this.searchKeywordFilter.setValue(response);
          }
        }
      })
    );
  }

  getWorkflowConfig() {
    from(this.configService.fetchConfig('loose_bbx')).subscribe(response => {
      if (response && response.data) {
        this.bbxWorkflow = response.data[0];
        this.looseBbx = this.bbxWorkflow === 'Yes' ? true : false;
        sessionStorage.setItem('loose-bbx', this.bbxWorkflow);
      }
    });
  }

  getDecimalUnitPrice() {
    from(this.configService.fetchConfig('unitPriceDecimalPoints')).subscribe(response => {
      if (response) {
        this.decimalValue = parseInt(response.data[0].unitPriceDecimalPoints);
      }
    });
  }

  getAllSetConfigs() {
    this.configService
      .getConfig(createConfig(allconfig))
      .pipe(
        concatMap(response => {
          const putConfigObservables = response.map(item => {
            if (Object.keys(item).length !== 0) {
              return this.configService.putConfig(item.config_id, item.data);
            } else {
              return of(null);
            }
          });
          return forkJoin(putConfigObservables);
        })
      )
      .subscribe(() => {
        this.getDecimalUnitPrice();
        this.getWorkflowConfig();
        this.getInvoiceConfigs();
        this.getPiecesConfig();
      });
  }

  checkIndexedTableData() {
    this.dexieDbService.getAllDataFromMyTable().then(data => {
      if (!(data.length > 0)) {
        this.getAllSetConfigs();
      } else {
        this.getDecimalUnitPrice();
        this.getWorkflowConfig();
        this.getInvoiceConfigs();
        this.getPiecesConfig();
      }
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          const rQuery = {
            query: {
              daterange: {
                datefield: this.getDateBasedOnTabFOrQuery(this.selectedTabForStatus),
                fromdate: this.fromdate,
                todate: this.todate,
              },
              status: this.getCurrentStatus(this.selectedTabForStatus),
            },
            limit: this.paginator.pageSize,
            page: this.paginator.pageIndex + 1,
            search: this.searchKeywordFilter.value == null ? '' : this.searchKeywordFilter.value,
            sort:
              this.sort.active === 'shipmentDate'
                ? this.getDateBasedOnTab(this.selectedTabForStatus)
                : this.sort.active,
            sortOrder: this.sort.direction === 'desc' ? -1 : 1,
          };
          return this.configService
            .getallSpecList(rQuery)
            .pipe(catchError(() => observableOf(null)));
        }),
        map(empData => {
          if (empData == null) {
            this.totalData = 0;
            return [];
          }
          return empData;
        })
      )
      .subscribe(empData => {
        this.assignDataSource(empData);
      });
  }

  getDateBasedOnTab = currentTab => {
    switch (currentTab) {
      case 0:
        return 'uploadDatetime';
      case 1:
        return !this.pieceLevelLabelPrint ? 'printedDate' : 'piecePrintedDate';
      case 2:
        return 'manifestedDate';
      default:
        return 'uploadDatetime';
    }
  };

  getDateBasedOnTabFOrQuery = currentTab => {
    switch (currentTab) {
      case 0:
        return 'upload_datetime';
      case 1:
        return 'printed_date';
      case 2:
        return 'manifested_date';
      default:
        return 'upload_datetime';
    }
  };

  disableSortArrowManifest() {
    return (this.looseBbx && this.selectedTabForStatus == 1) || this.selectedTabForStatus == 2;
  }

  disableSortArrow() {
    return this.looseBbx && (this.selectedTabForStatus == 1 || this.selectedTabForStatus == 2);
  }

  openUploadInvoices(shipmentID, motherStatus) {
    const dialogRef = this.dialog.open(UploadComponent, {
      autoFocus: false,
      width: '75vw',
      maxHeight: '100vh',
      maxWidth: '90vw',
      data: {
        isOpeningFrom: 'uploadInvoice',
        shipmentID,
        motherStatus,
      },
    });
    dialogRef.afterClosed().subscribe(() => ``);
  }

  getPLTValue() {
    this.configService.fetchConfig(allconfig.PAPERLESS_TRADE).then(response => {
      this.paperLesstTrade = response?.data[0]?.paperlessTrade === 'Yes' ? true : false;
      if (this.paperLesstTrade && this.selectedTabForStatus === 0) {
        if (!this.displayedColumns.includes('InvoiceAction')) {
          this.displayedColumns.push('InvoiceAction');
        }
      } else {
        const index = this.displayedColumns.indexOf('InvoiceAction');
        if (index !== -1) {
          this.displayedColumns.splice(index, 1);
        }
      }
    });
  }

  getProductCodeValues() {
    this.configService
      .getConfigs(createConfigArray(configurationIdMapForProductName))
      .then(response => {
        if (response && response[0]?.data) {
          this.nonDocProductCodes = response[0]?.data
            .filter(item => item?.showLineItem === true)
            .map(item => item?.productCode);
        }
      });
  }

  formatWarnings(warnings: string[]): string {
    return warnings.map((w, i) => `${i + 1}. ${w}`).join('\n'); // use newline characters
  }

  manifestIndividualBabyshipment(shipmentID, productCode) {
    const data = {
      shipmentID: shipmentID,
      productCode: productCode,
    };
    return this.shipmentService.individualBabyManifest(data);
  }

  handleManifestResponse(shipmentID, response: any) {
    const isSuccess = response?.error?.length == 0;
    if (isSuccess) {
      this.printLabelForIndShip(shipmentID);
      this.behaviourService.sendEvent('labelGenerated');
      this.onStatusTabChange({ index: 0 });
    }
  }

  printLabelForIndShip(shipmentID) {
    this.shipmentService.getIndividuaShiplabel('individualShipmentID', shipmentID).subscribe({
      next: data => {
        this.shipmentService.labelWindowPrint(data.label);
      },
    });
  }
}
